module.exports = __webpack_public_path__ + "static/media/image1.de086fcf.jpg";